module.exports = __webpack_public_path__ + "static/media/mastodon-logo-white.27706d37.svg";